import { AddIcon, MinusIcon } from "@chakra-ui/icons";
import { Box, chakra, HStack, IconButton, Text, Stack } from "@chakra-ui/react";
import { KYDWhitelabelTicketType } from "@common/interfaces/KYDTicket";

const TicketTypeQuantityWidget = ({
  updateQuantity,
  tt,
  quantities,
}: {
  updateQuantity: (
    ticket_type: KYDWhitelabelTicketType,
    action: string,
    value?: number
  ) => void;
  tt: KYDWhitelabelTicketType;
  quantities: any;
}) => {
  const canSubtract = (quantities.draftCart[tt.id] || 0) - tt.increment >= 0;

  // Can add when total of cart + draft cart + increment is less than limit
  // and if there's remaining, then the draft cart + increment has to be less than remaining (updated on cart update)
  const canAdd =
    (quantities.draftCart[tt.id] || 0) + (quantities.cart[tt.id] || 0) + tt.increment <= tt.limit &&
    (tt.remaining === undefined || (quantities.draftCart[tt.id] || 0)+ tt.increment <= tt.remaining);

  return (
    <Stack spacing={1}>
      <HStack py={1} w="100%" justify={"flex-end"}>
        <IconButton
          onClick={() => updateQuantity(tt, "sub")}
          aria-label="Subtract"
          icon={<MinusIcon />}
          disabled={!canSubtract}
          isDisabled={!canSubtract}
        />
        <Text fontWeight={"bold"} textAlign={"center"} minW={"20px"}>
          {quantities.draftCart[tt.id] || 0}
        </Text>
        <IconButton
          onClick={() => updateQuantity(tt, "add")}
          aria-label="Add"
          icon={<AddIcon />}
          disabled={!canAdd}
          isDisabled={!canAdd}
        />
      </HStack>
      {tt.remaining !== undefined && tt.remaining <= tt.limit ? (
        <Text
          w="100%"
          textAlign={"right"}
          fontWeight={"medium"}
          fontSize={"xs"}
          color="red.500"
        >{`${tt.remaining} remaining`}</Text>
      ) : null}
    </Stack>
  );
};

export default TicketTypeQuantityWidget;
